import MainLayout from "../../layouts/MainLayout";
import { IoDocumentTextOutline, IoMailOutline, IoCallOutline } from "react-icons/io5";
import "./styles.css";

const sections = [
  {
    num: "١",
    title: "قبول الشروط",
    body: "مرحباً بك في عقاراتي. من خلال الوصول إلى موقعنا أو استخدام خدماتنا، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي من هذه البنود، يُرجى التوقف عن استخدام خدماتنا.",
  },
  {
    num: "٢",
    title: "تعريف المصطلحات",
    list: [
      "الخدمة: تشير إلى موقع وتطبيق عقاراتي وجميع الخدمات المقدمة من خلالهما.",
      "المستخدم: أي شخص يستخدم خدمات عقاراتي سواء كزائر أو عضو مسجّل.",
      "المحتوى: جميع النصوص والصور والبيانات والمعلومات المعروضة على المنصة.",
      "الحساب: حساب المستخدم المسجل في المنصة.",
    ],
  },
  {
    num: "٣",
    title: "أهلية الاستخدام",
    intro: "لاستخدام خدماتنا، يجب أن تكون:",
    list: [
      "لا تقل عن 18 عاماً أو لديك موافقة وليّ الأمر.",
      "تملك الصلاحية القانونية لإبرام اتفاقيات ملزمة.",
      "غير محظور من استخدام الخدمات بموجب القوانين الليبية.",
      "تقدم معلومات دقيقة وصحيحة أثناء التسجيل.",
    ],
  },
  {
    num: "٤",
    title: "تسجيل الحساب",
    intro: "عند إنشاء حساب في عقاراتي، فإنك توافق على:",
    list: [
      "تقديم معلومات صحيحة ومحدثة.",
      "الحفاظ على سرية كلمة المرور وعدم مشاركتها مع الآخرين.",
      "إخطارنا فوراً بأي استخدام غير مصرح به لحسابك.",
      "تحديث بياناتك عند الحاجة.",
      "مسؤوليتك الكاملة عن جميع الأنشطة التي تتم عبر حسابك.",
    ],
  },
  {
    num: "٥",
    title: "الاستخدام المقبول",
    intro: "تلتزم باستخدام خدمات عقاراتي للأغراض القانونية فقط، ويُمنع عليك:",
    list: [
      "مخالفة أي قوانين أو لوائح في دولة ليبيا.",
      "نشر محتوى مسيء أو مضلل أو مخالف للآداب العامة.",
      "محاولة الوصول غير المصرّح به إلى أنظمة المنصة.",
      "تعطيل أو التدخل في تشغيل الموقع أو التطبيق.",
      "استخدام المنصة لأغراض تجارية خارج نطاق خدماتها دون إذن.",
      "انتهاك حقوق الملكية الفكرية أو الخصوصية لأي طرف آخر.",
    ],
  },
  {
    num: "٦",
    title: "الملكية الفكرية",
    body: "جميع النصوص والتصاميم والشعارات والصور والبرمجيات في عقاراتي مملوكة للمنصة ومحميّة بموجب قوانين حقوق الملكية الفكرية. لا يجوز نسخها أو إعادة نشرها أو تعديلها دون إذن كتابي مسبق.",
  },
  {
    num: "٧",
    title: "المحتوى المقدم من المستخدمين",
    intro: "عند تقديم أي محتوى في المنصة، فإنك:",
    list: [
      "تمنح عقاراتي ترخيصاً غير حصري لاستخدامه لغرض العرض والتشغيل ضمن الخدمة.",
      "تؤكد أن المحتوى لا ينتهك أي حقوق لطرف آخر.",
      "تتحمل المسؤولية الكاملة عن دقة وصحة المحتوى.",
      "تقر بحق المنصة في حذف أو تعديل أي محتوى مخالف أو مضلل.",
    ],
  },
  {
    num: "٨",
    title: "التعاملات بين المستخدمين",
    body: "عقاراتي منصة لعرض الإعلانات والتواصل فقط، ولا تمثل المنصة أي طرف في المعاملات العقارية. أي تعامل أو دفع يتم بين المستخدمين يكون على مسؤوليتهم الشخصية.",
  },
  {
    num: "٩",
    title: "الخدمات المدفوعة",
    list: [
      "جميع الرسوم تُدفع مقدماً.",
      "الأسعار قابلة للتغيير.",
      "المبالغ غير قابلة للاسترداد إلا إذا تم النص على ذلك صراحةً.",
      "في حال عدم الدفع، يحق للمنصة تعليق الخدمة أو إيقافها.",
    ],
  },
  {
    num: "١٠",
    title: "الإنهاء أو التعليق",
    body: "يحق لعقاراتي تعليق أو إيقاف حسابك في أي وقت دون إشعار مسبق في حال مخالفة الشروط أو القوانين. كما يمكنك إيقاف حسابك متى شئت عبر التواصل مع الدعم الفني.",
  },
  {
    num: "١١",
    title: "إخلاء المسؤولية",
    body: "خدمات عقاراتي تُقدَّم \"كما هي\" و\"حسب الإتاحة\". لا تضمن المنصة دقّة أو اكتمال المعلومات أو موثوقية أي محتوى منشور. استخدامك للخدمة على مسؤوليتك الخاصة بالكامل.",
  },
  {
    num: "١٢",
    title: "تحديد المسؤولية",
    body: "لن تكون عقاراتي مسؤولة عن أي أضرار مباشرة أو غير مباشرة أو تبعية أو خسائر مالية ناتجة عن استخدامك للخدمة.",
  },
  {
    num: "١٣",
    title: "التعويض",
    body: "أنت توافق على تعويض عقاراتي وإعفائها من أي مطالبات أو خسائر أو تكاليف تنتج عن مخالفتك لهذه الشروط أو لأي قانون معمول به.",
  },
  {
    num: "١٤",
    title: "القانون والاختصاص القضائي",
    body: "تخضع هذه الشروط وتفسّر وفقاً لقوانين دولة ليبيا. تختص المحاكم الليبية وحدها بالنظر في أي نزاع ينشأ عن استخدام المنصة أو خدماتها.",
  },
  {
    num: "١٥",
    title: "التعديلات",
    body: "تحتفظ عقاراتي بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطار المستخدمين بالتغييرات الجوهرية عبر البريد الإلكتروني أو من خلال إشعار داخل التطبيق.",
  },
];

function TermsPage() {
  return (
    <MainLayout isTopBar screenTitle="شروط الاستخدام">
      <div className="sp-wrap" dir="rtl">

        <div className="sp-hero">
          <div className="sp-hero__icon">
            <IoDocumentTextOutline size={32} />
          </div>
          <h1 className="sp-hero__title">شروط الاستخدام</h1>
          <p className="sp-hero__sub">يرجى قراءة هذه الشروط بعناية قبل استخدام خدماتنا</p>
        </div>

        <div className="sp-doc-card">
          {sections.map(s => (
            <div key={s.num} className="sp-doc-section">
              <div className="sp-doc-section__head">
                <div className="sp-doc-section__num">{s.num}</div>
                <h2 className="sp-doc-section__title">{s.title}</h2>
              </div>
              {s.intro && <p>{s.intro}</p>}
              {s.body  && <p>{s.body}</p>}
              {s.list  && (
                <ul>
                  {s.list.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              )}
            </div>
          ))}

          {/* Section 16 — contact */}
          <div className="sp-doc-section">
            <div className="sp-doc-section__head">
              <div className="sp-doc-section__num">١٦</div>
              <h2 className="sp-doc-section__title">التواصل معنا</h2>
            </div>
            <p>لأي استفسارات أو ملاحظات، يمكنك التواصل مع إدارة المنصة عبر:</p>
            <div className="sp-contact-box">
              <div className="sp-contact-row">
                <IoMailOutline size={17} />
                contact@aqaraty.ly
              </div>
              <div className="sp-contact-row">
                <IoCallOutline size={17} />
                <span dir="ltr">+218 44 44 44 44</span>
              </div>
            </div>
            <p className="sp-last-update">
              آخر تحديث: {new Date().toLocaleDateString('ar-LY', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>

      </div>
    </MainLayout>
  );
}

export default TermsPage;
